/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { AngularDraggableModule } from 'angular2-draggable';
import { HotKeysDirective } from './hotkeys/hot-keys.directive';
import { HotKeyService } from './hotkeys/hot-key.service';
import { FlexiblePanelComponent } from './flexible-panel/flexible-panel.component';
import { AlertComponent } from './alert/alert.component';
import { DashGisOverlayContainer } from './overlay/dash-gis-overlay-container.service';
import { DashGisOverlay } from './overlay/dash-gis-overlay.service';
import { ZoomButtonModule } from './zoomButton/zoom-button.module';
import { PdfDialogComponent } from './pdf/pdf-dialog.component';
import { SharedModule } from '../../modules/shared/shared.module';
import { ConfirmComponent } from './confirm/confirm.component';
import { HtmlSnackbarComponent } from './html-snackbar/html-snackbar.component';
import { WindowRefService } from './services/windowRef.service';
import { PhoneInputComponent } from './formfields/phone-input/phone-input.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { DateRangeComponent } from './formfields/date-range/date-range.component';
import { NumberRangeComponent } from './formfields/number-range/number-range.component';
import { DashGisNg2ResizableModule } from './dash-gis-ng2-resizable/dash-gis-ng2-resizable.module';

/**
 * UIModule - Shared module for all the common UI widgets used throughout the app.
 */
@NgModule({
    declarations: [
        AlertComponent,
        ConfirmComponent,
        HotKeysDirective,
        FileUploadComponent,
        FlexiblePanelComponent,
        HtmlSnackbarComponent,
        PdfDialogComponent,
        PhoneInputComponent,
        DateRangeComponent,
        NumberRangeComponent,
    ],
    exports: [
        AlertComponent,
        ConfirmComponent,
        HotKeysDirective,
        FileUploadComponent,
        FlexiblePanelComponent,
        PdfDialogComponent,
        PhoneInputComponent,
        DateRangeComponent,
        NumberRangeComponent,
    ],
    imports: [SharedModule, DashGisNg2ResizableModule, AngularDraggableModule, ZoomButtonModule],
    providers: [HotKeyService, WindowRefService, DashGisOverlayContainer, DashGisOverlay],
})
export class UiModule {}
